import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AppService } from '../../../features/user/services/app.service';
import { ToastContainerDirective } from 'ngx-toastr';
import { CategoriesService } from 'app/features/user/services/categories.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  router = inject(Router);
  Categories: any[] = [];
  companyLinks = [
    { label: 'About us', route: '/about-us' },
    { label: 'Contact us', route: '/contact-us' },
    { label: 'Terms and conditions', route: '/terms-and-conditions' },
    { label: 'Privacy policy', route: '/privacy-policy' },
  ];
  quickLinks = [
    { label: 'Become a user', route: '/auth/detect-type' },
    { label: 'Become a service provider', route: '/auth/detect-type' },
    { label: 'Shuwier guide', route: '/guide-tips' },
    { label: 'Shuwier answers (FAQ)', route: '/faq' },
  ];
  socialLinks = [
    {
      link: '#',
      icon: 'social/Group-3.svg', //fb
    },
    {
      link: '#',
      icon: 'social/Group.svg', // Instagram
    },
    {
      link: '#',
      icon: 'social/Group-2.svg', // X
    },
    {
      link: '#',
      icon: 'social/Group-4.svg', // YouTube
    },
    {
      link: '#',
      icon: 'social/Group-1.svg', // LinkedIn
    },
    {
      link: '#',
      icon: 'social/tiktok.svg', // Tiktok
    },
  ];
  socialAPILinks: any = [];
  mergedSocialLinks: any[] = [];

  constructor(
    private service: AppService,
    private categoriesServices: CategoriesService
  ) {}
  ngOnInit(): void {
    this.getCategories();
    this.getSocialMediaLinks();
  }
  getCategories() {
    this.categoriesServices.getServiceCategories().subscribe({
      next: (res: any) => {
        this.Categories = res.data.slice(0, 4);
      },
      error: (err: any) => {},
    });
  }
  getSocialMediaLinks() {
    this.service.getSocialMediaLinks().subscribe({
      next: (res: any) => {
        this.socialAPILinks = res.data;
        this.mergedSocialLinks = [
          {
            link: this.socialAPILinks.facebook_url,
            icon: 'social/Group-3.svg',
          },
          {
            link: this.socialAPILinks.instagram_url,
            icon: 'social/Group.svg',
          },
          {
            link: this.socialAPILinks.x_url,
            icon: 'social/Group-2.svg',
          },
          {
            link: this.socialAPILinks.youtube_url,
            icon: 'social/Group-4.svg',
          },
          {
            link: this.socialAPILinks.linkedin_url,
            icon: 'social/Group-1.svg',
          },
          {
            link: this.socialAPILinks.tiktok_url,
            icon: 'social/tiktok.svg',
          },
        ];
      },
      error: (err: any) => {},
    });
  }
  navigateToCategory(item: any) {
    this.router.navigate(['/client/services'], {
      state: { category: item.id },
    });
  }
}
